import megatron from '@ibibo/megatron';

const GENERATE_OTP_URL = `${__ENV_CONFIG__.MYPARTNER}/agents/validate_agent/`;

export default async function generateOTP(data) {
  return await megatron({
    name: 'register user api',
    url: GENERATE_OTP_URL,
    type: 'POST',
    credentials: 'include',
    requestData: data,
  });
};

